/* T8 product card: wishlist toggle (localStorage) + quick add (POST /cart/add.js → tamyra:cart:updated) */
(function () {
  'use strict';
  var KEY = 't8-wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveWl(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function addToCart(id, qty) {
    if (window.TamyraCart && window.TamyraCart.add) return window.TamyraCart.add([{ id: id, quantity: qty || 1 }]);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Cart error'); return d; }); })
      .then(function (d) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
          document.dispatchEvent(new CustomEvent('tamyra:cart:updated', { detail: { cart: cart, added: d } }));
          return d;
        });
      });
  }
  window.T8Cart = window.T8Cart || { add: addToCart };

  /* saved state: filled heart + label; every button for the same product stays in step */
  function paintWish(btn, on) {
    btn.setAttribute('aria-pressed', String(on));
    var label = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    if (label) btn.setAttribute('aria-label', label);
  }
  function paintAll() {
    var list = wl();
    document.querySelectorAll('[data-t8-wishlist]').forEach(function (b) { paintWish(b, list.indexOf(b.dataset.t8Wishlist) > -1); });
    document.querySelectorAll('[data-t8-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  document.addEventListener('t8:wishlist:updated', paintAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintAll(); });
  window.T8Wishlist = { list: wl, save: saveWl, paint: paintAll };

  function init(root) {
    (root || document).querySelectorAll('[data-t8-pcard]').forEach(function (card) {
      if (card.dataset.ready) return; card.dataset.ready = '1';
      // the whole card opens the product page; swatches, selects, quantity, buttons and links keep their own job
      card.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.target.closest('a, button, select, input, label, textarea, [role="radio"]')) return;
        var link = card.querySelector('.t8-pcard__title'); if (!link || !link.href || link.getAttribute('href') === '#') return;
        if (e.metaKey || e.ctrlKey) window.open(link.href, '_blank'); else window.location.href = link.href;
      });
      card.addEventListener('auxclick', function (e) {
        if (e.button !== 1 || e.target.closest('a, button, select, input, label, textarea, [role="radio"]')) return;
        var link = card.querySelector('.t8-pcard__title'); if (link && link.href && link.getAttribute('href') !== '#') window.open(link.href, '_blank');
      });
      var wish = card.querySelector('[data-t8-wishlist]');
      if (wish) {
        var handle = wish.dataset.t8Wishlist;
        paintWish(wish, wl().indexOf(handle) > -1);
        wish.addEventListener('click', function (e) {
          e.preventDefault();
          var list = wl(), i = list.indexOf(handle);
          if (i > -1) list.splice(i, 1); else list.unshift(handle);
          saveWl(list);
          document.dispatchEvent(new CustomEvent('t8:wishlist:updated', { detail: { handle: handle, list: list, added: i === -1 } }));
        });
      }
      var quick = card.querySelector('[data-t8-quick-add]');
      if (quick) quick.addEventListener('click', function () {
        var id = Number(quick.dataset.t8QuickAdd);
        if (!id) { if (quick.dataset.url) window.location.href = quick.dataset.url; return; }
        quick.classList.add('is-busy');
        addToCart(id, 1).then(function () {
          quick.classList.remove('is-busy'); quick.classList.add('is-done');
          setTimeout(function () { quick.classList.remove('is-done'); }, 1600);
        }, function () { quick.classList.remove('is-busy'); if (quick.dataset.url) window.location.href = quick.dataset.url; });
      });
    });
  }
  /* hover photos (snippets/t8-product-card.liquid renders them without src): devices that can hover get them once the page has
     loaded (and at once on the first hover); touch devices never download them */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches, pageLoaded = document.readyState === 'complete';
  function fillAlt(img) {
    if (!img || !img.dataset.t8Src) return;
    if (img.dataset.t8Srcset) img.srcset = img.dataset.t8Srcset;
    img.src = img.dataset.t8Src; img.removeAttribute('data-t8-src'); img.removeAttribute('data-t8-srcset');
  }
  function fillAll(root) { if (canHover && pageLoaded) (root || document).querySelectorAll('.t8-pcard__img--alt[data-t8-src]').forEach(fillAlt); }
  if (canHover) {
    document.addEventListener('pointerover', function (e) { var c = e.target.closest && e.target.closest('[data-t8-pcard]'); if (c) fillAlt(c.querySelector('.t8-pcard__img--alt[data-t8-src]')); }, { passive: true });
    if (!pageLoaded) window.addEventListener('load', function () { pageLoaded = true; if (window.requestIdleCallback) requestIdleCallback(function () { fillAll(); }, { timeout: 2500 }); else setTimeout(fillAll, 1500); });
  }
  function boot() { init(document); paintAll(); fillAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); paintAll(); });
  /* collection filters / sort / pages swap the cards in: wire the new ones */
  document.addEventListener('t8:collection:updated', function (e) { init(e.detail && e.detail.section); paintAll(); fillAll(e.detail && e.detail.section); });
  document.addEventListener('t8:cards:added', function (e) { init(e.detail && e.detail.root); paintAll(); });
})();
